import {Component} from "preact";
import ToolbarButton from "../../../../../common/toolbar-button";
import styles from './styles.scss';
import Toolbar from "../../../../../layout/toolbar";

export default class ContactItem extends Component {
    static defaultProps = {
        item: {},
        selected: false,
        onToggle: () => {}
    };

    render(props, state, context) {
        const x = <div class={styles.check}></div>;

        return (
            <Toolbar>
                <ToolbarButton type={'fill'} onClick={this.toggle}>
                    <div class={styles.container}>
                        <div class={styles.contactCheckbox}>
                            {this.props.selected ? x : null}
                        </div>
                        <div class={styles.contactBody}>
                            {props.item.username}
                        </div>
                    </div>
                </ToolbarButton>
            </Toolbar>
        );
    }

    toggle = () => {
        this.props.onToggle(this.props.item.id);
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/contact-item/index.js